import React, { useEffect, useState } from 'react'
import { ifloorplanStateAdd,
        addPlan } from 'New/redux/actions/actions';
import { connect } from 'react-redux';

const CropTool = (props) => {
    
    return (
        <div className="topPanelWrap crop"
            style={{display: props.isPanning ? 'block' : 'none'}}>
            <button className="cropDone"
                onClick={props.togglePanView}>
                Done
            </button>
        </div>
    )
}

const putState = (state) => {
    return {
        ifloorplanNowState: state.ifloorplanNowState,
        levelNowId: state.levelNowId,
        step: state.step,
        plans: state.plans
    }
}

const putActions = (dispatch) => {
    return {
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        addPlan: (plan) => dispatch(addPlan(plan)),
    }
}

export default connect(putState, putActions)(CropTool);